import React, { useEffect } from "react";
import "../App.css";
import { useOutletContext } from "react-router-dom";

import TermsAndConditionsPage from "../components/termsAndConditions/termsAndConditions";

export default function TermsAndConditions() {
  const [
    auth,
    setAuth,
    user,
    setUser,
    darkmode,
    setDarkmode,
    nav,
    setNav,
    setError,
  ]: any = useOutletContext();

  useEffect(() => {
    // setNav({ ...nav, page: "profile" });
  }, []);

  return (
    <div className="row">
      <TermsAndConditionsPage />
    </div>
  );
}
